require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./neighborhood-park-watch.json") })
        }
      }, "path---neighborhood-park-watch");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---neighborhood-park-watch!./.cache/json/neighborhood-park-watch.json
// module id = 940
// module chunks = 231608221292675